import moment from 'moment-timezone'
import { capitalize } from 'utils/capitalize'
import { FORMATS } from 'constants/datetime'
import { DISPLAY } from 'constants/display'
import { stopTypes } from 'constants/facilities'
import { IStop } from './types/stops'

export const formatDate = (date: string) => moment(date).format(FORMATS.dayFormat)
export const currentStopType = (stopType: NonNullable<IStop['stopType']>) =>
  stopTypes[stopType].toLowerCase()
export const getStopIdentifier = (stop: IStop) => {
  if (stop.po) {
    return `PO: ${stop.po}`
  }

  if (stop.bol) {
    return `BOL: ${stop.bol || DISPLAY.empty}`
  }

  return `BOL: ${DISPLAY.na}`
}

export const alreadyConfirmedText = (stop: IStop, stopType: NonNullable<IStop['stopType']>) =>
  `${capitalize(stopType)} Confirmed for ${getStopIdentifier(stop)}`
export const appointmentDate = (stop: IStop, apptType: NonNullable<IStop['appointmentType']>) =>
  `${formatDate(stop.startAtDate || '')} (${stop.startAtTime} ${
    (apptType === 'range' || apptType === 'fcfs') && stop.endAtTime ? `- ${stop.endAtTime} ` : ''
  }${stop.timezone})`
export const unconfirmedAppointmentDate = (stop: IStop) => {
  return `${formatDate(stop.startAtDate || '')}`
}
